<div class="custom_select" *ngIf="showZahlungsart">
  <div class="text_info">
    <app-label [control]="zahlungsart" class="custom-select__label" for="zahlungsart">Prämie für folgende Zahlungsweise anzeigen:</app-label>
    <div class="info">
      <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ZAHLUNGSWEISEINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
    </div>
  </div>
  <mat-form-field>
    <mat-select id="zahlungsart" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" [formControl]="zahlungsart" [compareWith]="lookupService.compareValues">
      <mat-option *ngFor="let za of dataService.zahlungsarten | async" [value]="za">{{ za.Value }}</mat-option>
    </mat-select>
    <mat-error *ngIf="zahlungsart.hasError('required')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
  </mat-form-field>
</div>
